import { Vertical } from "gls/lib";
import { observer } from "mobx-react";
import { useRef } from "react";
import { ScrollButton } from "./ScrollButton";
import { usePageScroll } from "./usePageScroll";

export type ScrollingContainerProps = {
  children: React.ReactNode;
  showTopButton?: boolean;
  topButtonButtomPosition?: number;
};

const ScrollingContainer = observer(
  (props: ScrollingContainerProps) => {
    const boundingElementRef = useRef<HTMLDivElement>(null);
    const elementRef = useRef<HTMLDivElement>(null);
    const { handleScroll, showOnScroll } = usePageScroll(
      boundingElementRef,
      elementRef
    );

    return (
      <Vertical
        spacing={0}
        sizing="stretch"
        style={{
          overflowY: "auto",
          overflowX: "hidden",
        }}
        ref={boundingElementRef}
        scroll="vertical"
      >
        <Vertical ref={elementRef} sizing="stretch" spacing={0}>
          {props.children}
        </Vertical>
        {props.showTopButton && showOnScroll &&
          <ScrollButton onClick={handleScroll} bottom={`${props.topButtonButtomPosition ?? 10}px`} />}
      </Vertical>
    );
  }
);

export default ScrollingContainer;
